import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import Cookie from 'js-cookie';



export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authReq = req.clone({withCredentials: true});
    const router = inject(Router);
    const toastr = inject(ToastrService)

    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            switch (error.status) {
                case 401:
                    router.navigate(['/login']);
                    localStorage.removeItem('user');
                    localStorage.removeItem('user_detail');
                    Cookie.remove('ttd-session');
                    toastr.error('Session expired. Please login again.', 'Authentication Required');
                    break;
                case 403:
                    localStorage.removeItem('user');
                    localStorage.removeItem('user_detail');
                    Cookie.remove('ttd-session');
                    const errorMessage = error.error?.message || 'Access denied';
                    const toastMessage = errorMessage === 'Insufficient permission' 
                        ? 'You don\'t have permission to perform this action. Please contact your administrator if you believe this is an error.'
                        : errorMessage;
                    toastr.warning(toastMessage, 'Access Denied', {
                        timeOut: 5000,
                        extendedTimeOut: 2000,
                        closeButton: true,
                        progressBar: true
                    });
                    router.navigate(['/login']);
                    break;                   
            }
            return throwError(() => error);
        })
    );
};